export default "__VITE_ASSET__9c9808d0__"